import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class Markers {
    constructor() {

		this.markers = null;

		document.addEventListener('bless', (e) => {
			this.markers = e.target.querySelectorAll('[data-marker]');
            this.setTriggers();
		});

    }

    setTriggers() {
        this.markers.forEach(marker => {
            new ScrollTrigger({
                trigger: marker,
                start: 'center 75%',
                onEnter: () => {
                    marker.querySelectorAll('mark').forEach(elm => {
                        elm.classList.add('is-visible');
                    });
                }
            });
        });
    }
}